export default __webpack_public_path__ + "static/media/email.420ce780.svg";